<div class="section">
    <h1 *ngIf="getEinstellung('Titel')">{{ getEinstellung('Titel') }}</h1>

    <ng-template ngFor let-vo [ngForOf]="unterschriften">
        <div class="ion-activatable" appClick (clicked)="onStarteUnterschrift(vo.rolle)" [class.hidden]="vo.hidden">
            <h2>{{ getEinstellung(vo.rolle + '-Titel', vo.getRolleLang()) }}: {{ vo.name }}</h2>

            <div *ngIf="vo.bild" [style.height]="vo.height">
                <div class="unterschrift-container vorhanden" [class.disabled]="unterschriftLaeuft" [class.heightVorhanden]="!!vo.height">
                    <img [src]="domSanitizationService.bypassSecurityTrustUrl(vo.bild)" />
                </div>
            </div>
            <div *ngIf="!vo.bild">
                <div *ngIf="(vo.erforderlich | async)" class="unterschrift-container erforderlich" [class.disabled]="unterschriftLaeuft" [style.height]="vo.height">
                    {{ 'Unterschrift erforderlich' | translate }}.<br />{{ 'Zum unterschreiben hier tippen' | translate }}.
                </div>
                <div *ngIf="!(vo.erforderlich | async)" class="unterschrift-container optional" [class.disabled]="unterschriftLaeuft" [style.height]="vo.height">
                    {{ 'Zum unterschreiben hier tippen' | translate }}.
                </div>
            </div>
        </div>
    </ng-template>

    <div class="divider-space"></div>
</div>